import countryCodeToNameMapping from 'api/data/countryCodeToNameMapping'
import { getCountryName as getCountryNameRaw } from 'modules/BioriskMpox/Epidemiology'

export const getCountryName = (name: string) => {
  return getCountryNameRaw(name, {
    ...countryCodeToNameMapping,
    GBR: 'England',
  })
}
